//src/pages/CreatorDashboard.jsx

import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  createSupportAsset,
  getSupportAssets,
  getMyAssets
} from "../services/support_assets";

const CreatorDashboard = () => {
  const navigate = useNavigate();

  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [myAssets, setMyAssets] = useState([]);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [platform, setPlatform] = useState("tiktok");
  const [contentLink, setContentLink] = useState("");

  const [submitting, setSubmitting] = useState(false);

  // =========================
  // FETCH ASSETS
  // =========================
  useEffect(() => {
    const fetchAssets = async () => {
      try {

        const publicAssets = await getSupportAssets();

        setAssets(publicAssets);
      } catch (err) {
        console.error("Fetch public assets error:", err);
      }

      try {
        const token = localStorage.getItem("token");

        if (token) {
          const creatorAssets = await getMyAssets(token);

          setMyAssets(creatorAssets);
        }
      } catch (err) {
        console.error("Fetch my assets error:", err);
        setMyAssets([]);
      }
      
      setLoading(false);
    };

    fetchAssets();
  }, []);



       
  // =========================
  // CREATE ASSET
  // =========================
  const handleUpload = async () => {
    if (submitting) return;

    if (!title || !description || !contentLink) {
      alert("Fill all fields");
      return;
    }

    if (myAssets.length >= 1) {
      alert("You can only create one creator page");
      return;
    }

    try {
      setSubmitting(true);

      const token = localStorage.getItem("token");

      await createSupportAsset(
        {
          title,
          description,
          platform,
          content_link: contentLink,
        },
        token
      );

      const data = await getSupportAssets();
      setAssets(data);

      setTitle("");
      setDescription("");
      setContentLink("");

      alert("🔥 Asset created successfully!");
    } catch (err) {
      console.error("Upload error:", err);
      alert("Upload failed");
    } finally {
      setSubmitting(false);
    }
  };

  // =========================
  // NAVIGATE TO SUPPORT PAGE
  // =========================
  const goToSupport = (creatorName, amount) => {
    const packageTypeMap = {
      1000: "coffee",
      5000: "burger",
      10000: "crown",
    };

    const selectedPackage =
      packageTypeMap[amount] || "custom";

    navigate(
      `/support/${creatorName}/${selectedPackage}`
    );
  };

  // =========================
  // COPY LINK
  // =========================
  const copyLink = (displayName) => {
    if (!displayName) {
      alert("No display name found");
      return;
    }

    const link = `https://creator-yard.com/creator/${displayName}`;

    navigator.clipboard.writeText(link);

    alert("🔗 Link copied!");
  };

  // =========================
  // PREVIEW PROFILE
  // =========================
  const previewProfile = (displayName) => {
    if (!displayName) {
      alert("No creator name found");
      return;
    }

    const url = `https://creator-yard.com/creator/${displayName}`;

    window.open(
      url,
      "_blank",
      "noopener,noreferrer"
    );
  };

  // =========================
  // WATCH VIDEO
  // =========================
  const watchVideo = async (asset) => {
    if (!asset?.content_link) return;

    window.open(
      asset.content_link,
      "_blank",
      "noopener,noreferrer"
    );

    setAssets((prev) =>
      prev.map((a) =>
        a.id === asset.id
          ? {
              ...a,
              clicks: (a.clicks || 0) + 1,
            }
          : a
      )
    );

    fetch(
      `https://creator-mvp-hvdx.onrender.com/support-assets/click/${asset.slug}`,
      {
        method: "POST",
      }
    ).catch(() => {});
  };

  // =========================
  // LOADING
  // =========================
  if (loading) {
    return <h2>Loading... ⏳</h2>;
  }

  return (
    <div className="container">

      <h2>🎬 Creator Studio</h2>

      {/*TRUST BAR*/}

      <div
        style={{
          marginTop: 10,
          marginBottom: 20,
          padding: "14px 18px",
          borderRadius: 14,
          background: "#fff",
          border: "2px solid #f1f5f9",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 10,
          boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 16,
              fontWeight: "bold",
              color: "#111827",
            }}
          >
            🔒 Payments Secured by Flutterwave
          </div>

          <div
            style={{
              fontSize: 13,
              color: "#6b7280",
              marginTop: 4,
            }}
          >
            Trusted payment infrastructure powering creator support payouts.
          </div>
        </div>

        <div
          style={{
            background: "#fb923c",
            color: "#fff",
            padding: "8px 14px",
            borderRadius: 999,
            fontWeight: "bold",
            fontSize: 13,
          }}
        >
          VERIFIED PAYMENT SYSTEM
        </div>
      </div>

      {/* CREATE */}
      <div className="card">
        <h3>Setup Your Creator Page</h3>

        <input
          className="input"
          placeholder="Creator headline"
          value={title}
          onChange={(e) =>
            setTitle(e.target.value)
          }
        />

        <textarea
          className="textarea"
          placeholder="Tell fans why they should support you"
          value={description}
          onChange={(e) =>
            setDescription(e.target.value)
          }
        />

        <select
          className="select"
          value={platform}
          onChange={(e) =>
            setPlatform(e.target.value)
          }
        >
          <option value="tiktok">TikTok</option>
          <option value="instagram">Instagram</option>
          <option value="x">X</option>
          <option value="facebook">Facebook</option>
        </select>

        <input
          className="input"
          placeholder="Profile link"
          value={contentLink}
          onChange={(e) =>
            setContentLink(e.target.value)
          }
        />

        <button
          className="button"
          disabled={submitting}
          onClick={handleUpload}
        >
          {submitting
            ? "Processing..."
            : "Launch Creator Page"}
        </button>
      </div>

      {/* LIST */}
      <div className="card">
        {assets.map((a) => (
          <div
            key={a.id}
            style={{
              borderBottom: "1px solid #eee",
              padding: 15,
            }}
          >
            {/* CREATOR */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
              }}
            >
              <img
                src={
                  a.creator?.profile_image ||
                  "https://via.placeholder.com/55"
                }
                alt={
                  a.creator?.display_name ||
                  "creator"
                }
                style={{
                  width: 55,
                  height: 55,
                  borderRadius: "50%",
                  border: "2px solid #22c55e",
                }}
              />

              <div>
                <h4 style={{ margin: 0 }}>
                  {a.creator?.display_name ||
                    "Creator"}
                </h4>
              </div>
            </div>

            {/* CONTENT */}
            <h3>{a.title}</h3>

            <p>{a.description}</p>

            {a.content_link && (
              <button
                onClick={() => watchVideo(a)}
              >
                ▶ Preview profile
              </button>
            )}

            {/* LINK */}
            <div
              style={{
                fontSize: 13,
                opacity: 0.6,
              }}
            >
              creator-yard.com/creator/
              {a.creator?.display_name}
            </div>

            {/* ACTIONS */}
            <div
              style={{
                display: "flex",
                gap: 10,
                marginTop: 10,
              }}
            >
              {/* COPY */}
              <button
                onClick={() =>
                  copyLink(
                    a.creator?.display_name
                  )
                }
              >
                Copy link
              </button>

              {/* PREVIEW */}
              <button
                onClick={() =>
                  previewProfile(
                    a.creator?.display_name
                  )
                }
              >
                Preview My Creator Page
              </button>
            </div>

            {/* SUPPORT SECTION */}
            <div
              style={{
                marginTop: 20,
                padding: 16,
                borderRadius: 16,
                background: "#f8fafc",
                border: "1px solid #e2e8f0",
              }}
            >
              <p
                style={{
                  fontSize: 18,
                  fontWeight: "bold",
                }}
              >
                ₦{a.total_support || 0} Total Support
              </p>

              <p
                style={{
                  fontSize: 13,
                  opacity: 0.7,
                }}
              >
                {a.support_count || 0} supporters
              </p>

              <div
                style={{
                  display: "flex",
                  gap: 10,
                  flexWrap: "wrap",
                  marginTop: 10,
                }}
              >
                <button
                  onClick={() =>
                    goToSupport(
                      a.creator?.display_name,
                      1000
                    )
                  }
                >
                  ☕ ₦1,000
                </button>

                <button
                  onClick={() =>
                    goToSupport(
                      a.creator?.display_name,
                      5000
                    )
                  }
                >
                  🍔 ₦5,000
                </button>

                <button
                  onClick={() =>
                    goToSupport(
                      a.creator?.display_name,
                      10000
                    )
                  }
                >
                  👑 ₦10,000
                </button>

                <button
                  onClick={() =>
                    goToSupport(
                      a.creator?.display_name,
                      "custom"
                    )
                  }
                >
                  💎 Custom
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CreatorDashboard;